export default __webpack_public_path__ + "static/media/img_introduce_banner_1.60bd5779.png";